import React from 'react';
import { Card, Accordion } from 'react-bootstrap';

 
export default function Step2APleated({
 ContextAwareToggle,
 t,
 step2,
 step2A,
 accordionActiveKey,
 requiredStep,
 stepSelectedLabel,
 step8,
 modalHandleShow,
 setSheerHeaderStyleTemp,
 setStep2A,
 setDeps,
 setCart,
 selectChanged,
 setSheersModelId,
 inputs,
 NextStep,
}) {
  return (
   <Card className={step2 !== "" ? "" : "noDisplay"}>
   <Card.Header
     className={
       step2A !== "" &&
       (!accordionActiveKey.startsWith("2") ||
         accordionActiveKey === "2B" ||
         accordionActiveKey === "2C")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="2A"
       stepNum={t("2A")}
       stepTitle={t("grommet_step2A")}
       stepRef="2A"
       type="1"
       required={requiredStep["2A"]}
       stepSelected={
         stepSelectedLabel["2A"] === undefined ? "" : stepSelectedLabel["2A"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="2A">
     <Card.Body>
       <div className="card_body card_body_radio card_body_radio_camera card_body_radio_small_img">
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/european/pleated2a.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("double european pleat")}
             value="1"
             name="step2A"
             ref-num="2A"
             id="2A1"
             checked={step2A === "Double European Pleat"}
             onChange={(e) => {
               if (
                 (step2A === "Inverted Box Pleat" || step2A === "Pencil Pleat") &&
                 step8 === "I Want To Customize Hardware Per Curtain"
               ) {
                 modalHandleShow("SheerHeaderStyleWarning");
                 setSheerHeaderStyleTemp({
                   stepValue: "Double European Pleat",
                   id: "0036",
                   cartValue: "Double European Pleat",
                   event: e,
                 });
               } else {
                 setStep2A("Double European Pleat");
                 setDeps("", "2A");
                 setCart(
                   "SheerHeaderStyle",
                   "Double European Pleat",
                   "",
                   "SheerHeaderStyleID",
                   ["0036"]
                 );
                 selectChanged(e);
                 setSheersModelId("0036");
               }
             }}
             ref={(ref) => (inputs.current["2A1"] = ref)}
           />
           <label htmlFor="2A1">{t("HeaderStyle5")}</label>
         </div>
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/grommet/Inverted_sketch.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Inverted Box Pleat")}
             value="2"
             name="step2A"
             ref-num="2A"
             id="2A2"
             checked={step2A === "Inverted Box Pleat"}
             onChange={(e) => {
               if (
                 (step2A === "Grommet" || step2A === "Rod Pocket") &&
                 step8 === "I Want To Customize Hardware Per Curtain"
               ) {
                 modalHandleShow("SheerHeaderStyleWarning");
                 setSheerHeaderStyleTemp({
                   stepValue: "Inverted Box Pleat",
                   id: "0036",
                   cartValue: "Inverted Box Pleat",
                   event: e,
                 });
               } else {
                 setStep2A("Inverted Box Pleat");
                 setDeps("", "2A");
                 setCart(
                   "SheerHeaderStyle",
                   "Inverted Box Pleat",
                   "",
                   "SheerHeaderStyleID",
                   ["0036"]
                 );
                 selectChanged(e);
                 setSheersModelId("0036");
               }
             }}
             ref={(ref) => (inputs.current["2A2"] = ref)}
           />
           <label htmlFor="2A2">{t("HeaderStyle2")}</label>
         </div>
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/grommet/pencilPleat.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Pencil Pleat")}
             value="3"
             name="step2A"
             ref-num="2A"
             id="2A3"
             checked={step2A === "Pencil Pleat"}
             onChange={(e) => {
               if (
                 (step2A === "Grommet" || step2A === "Rod Pocket") &&
                 step8 === "I Want To Customize Hardware Per Curtain"
               ) {
                 modalHandleShow("SheerHeaderStyleWarning");
                 setSheerHeaderStyleTemp({
                   stepValue: "Pencil Pleat",
                   id: "0001",
                   cartValue: "Pencil Pleat",
                   event: e,
                 });
               } else {
                 setStep2A("Pencil Pleat");
                 setDeps("", "2A");
                 setCart("SheerHeaderStyle", "Pencil Pleat", "", "SheerHeaderStyleID", [
                   "0001",
                 ]);
                 selectChanged(e);
                 setSheersModelId("0001");
               }
             }}
             ref={(ref) => (inputs.current["2A3"] = ref)}
           />
           <label htmlFor="2A3">{t("HeaderStyle3")}</label>
         </div>

         <NextStep currentStep={step2A !== "" ? "2" : "2A"} eventKey="2B">
           {t("NEXT STEP")}
         </NextStep>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
